import { Link, useLocation } from "react-router-dom"

import Style from "./style"
import logo from "./asset/logo.png"

import useRoleCookie from "shared/model/useRoleCookie"
import useNameCookie from "shared/model/useNameCookie"
import { convertRoleAsName } from "shared/constant/lookup/role"
import DefaultButton from "shared/ui/DefaultButton"

const Header = () => {
    const location = useLocation()
    const path = location.pathname.split("/")
    const target = path[path.length - 1]

    const [roleCookie] = useRoleCookie()
    const [nameCookie] = useNameCookie()

    return (
        <Style.Header $login={roleCookie && target !== "qr"}>
            <Link to="/">
                <Style.LogoImg src={logo} />
            </Link>
            {roleCookie && target !== "qr" &&
                <Style.ProfileDiv>
                    <p>{convertRoleAsName[roleCookie]}</p>
                    <h2>{nameCookie}</h2>
                </Style.ProfileDiv>
            }
        </Style.Header>
    )
}

export default Header